import { Component, OnInit } from '@angular/core';
import {LOG_LEVEL, LoggerService} from '@util/logger.service';
import {PassThroughService} from '@api/pass-through.service';

@Component({
  selector: 'app-smartfeed-help',
  templateUrl: './smartfeed-help.component.html',
  styleUrls: ['./smartfeed-help.component.scss']
})
export class SmartfeedHelpComponent implements OnInit {

  /**
   * Current Firmware
   */
  firmware: any;



  constructor(
    private passThroughService: PassThroughService,
    ) { }

  ngOnInit() {
    this.passThroughService.getSmartFeedFirmware().subscribe(
      data => {
        this.firmware = data;
      },
      error => {
        LoggerService.log(error, LOG_LEVEL.ERROR);
      },
    );
  }

}
